{
  "name": "@vercel/edge-config",
  "version": "1.5.1",
  "description": "Ultra-low latency data at the edge",
  "homepage": "https://vercel.com",
  "repository": {
    "type": "git",
    "url": "https://github.com/vercel/storage.git",
    "directory": "packages/edge-config"
  },
  "publishConfig": {
    "provenance": true
  },
  "license": "Apache-2.0",
  "sideEffects": false,
  "type": "module",
  "exports": {
    ".": {
      "next-js": {
        "import": "./dist/index.next-js.js",
        "require": "./dist/index.next-js.cjs"
      },
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    }
  },
  "main": "./dist/index.cjs",
  "module": "./dist/index.js",
  "files": [
    "dist"
  ],
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch --clean=false",
    "check": "biome check",
    "prepublishOnly": "pnpm run build",
    "publint": "npx publint",
    "test": "pnpm run test:node && pnpm run test:edge && pnpm run test:common",
    "test:common": "jest --env @edge-runtime/jest-environment .common.test.ts && jest --env node .common.test.ts",
    "test:edge": "jest --env @edge-runtime/jest-environment .edge.test.ts",
    "test:node": "jest --env node .node.test.ts",
    "type-check": "tsc --noEmit"
  },
  "jest": {
    "preset": "ts-jest",
    "setupFiles": [
      "<rootDir>/jest/setup.js"
    ],
    "testEnvironment": "node"
  },
  "dependencies": {
    "@vercel/global-config-fs": "workspace:*"
  },
  "devDependencies": {
    "@changesets/cli": "2.31.0",
    "@edge-runtime/jest-environment": "4.0.0",
    "@edge-runtime/types": "4.0.0",
    "@types/jest": "30.0.0",
    "@types/node": "24.12.2",
    "jest": "30.3.0",
    "jest-fetch-mock": "3.0.3",
    "next": "16.2.4",
    "node-domexception": "2.0.2",
    "ts-jest": "29.4.9",
    "tsconfig": "workspace:*",
    "tsup": "8.5.1",
    "typescript": "5.9.3"
  },
  "peerDependencies": {
    "@opentelemetry/api": "^1.7.0",
    "next": ">=1"
  },
  "peerDependenciesMeta": {
    "@opentelemetry/api": {
      "optional": true
    },
    "next": {
      "optional": true
    }
  },
  "engines": {
    "node": ">=14.6"
  }
}
